/**
 * El backend responde 409 tanto para "la encuesta ya se ha realizado" como para
 * "se ha alcanzado el número máximo de respuestas" (Survey.MaxAnswer). El status
 * code por sí solo no alcanza para distinguirlos, así que se compara el cuerpo.
 *
 * Toda la detección vive acá: si algún día el backend expone un código de error
 * propio, este es el único archivo que hay que tocar.
 */

// Fragmento estable del mensaje que devuelve SurveyAnswerLimitService desde
// AnswerController ("Se ha alcanzado el número máximo de respuestas...").
const MAX_ANSWERS_HINT = 'maximo de respuestas';

/**
 * Pasa el valor a texto plano, sin tildes y en minúsculas, para comparar sin
 * depender de la forma exacta del cuerpo (string suelto u objeto).
 *
 * @param data
 * @returns {string}
 */
const normalize = (data) => {
  let text = '';

  if (typeof data === 'string') {
    text = data;
  } else if (data) {
    try {
      text = JSON.stringify(data);
    } catch (e) {
      text = '';
    }
  }

  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

/**
 * True si el par (status, cuerpo) corresponde al tope de respuestas.
 *
 * @param status
 * @param data
 * @returns {boolean}
 */
export const isMaxAnswersResponse = (status, data) =>
  status === 409 && normalize(data).includes(MAX_ANSWERS_HINT);

/**
 * Igual que isMaxAnswersResponse, pero recibiendo el error de axios.
 *
 * @param error
 * @returns {boolean}
 */
export const isMaxAnswersError = (error) =>
  isMaxAnswersResponse(error?.response?.status, error?.response?.data);

/**
 * Igual que isMaxAnswersResponse, pero recibiendo el payload que los thunks
 * rechazados guardan en el store ({ status, data }).
 *
 * @param payload
 * @returns {boolean}
 */
export const isMaxAnswersPayload = (payload) =>
  isMaxAnswersResponse(payload?.status, payload?.data);
